<app-order-grid-filter
  [ordersList]="orders"
  [defaultOrderOwner]="defaultOrderOwner"
  [orderVocab]="orderVocab"
  [externalUser]="externalUser"
  [users]="users"
  [orderOwnerList]="orderOwnerList"
  [ordersListFilter]="ordersListFilter"
  (filterChange)="onFilterChange($event)"
  (emitAccountNames)="getAccountNames($event)">
</app-order-grid-filter>

<app-order-grid
  [orders]="orders"
  [orderVocab]="orderVocab"
  [loading]="loading"
  [totalRecords]="totalRecords"
  [error]="error"
  [externalUser]="externalUser"
  [users]="users"
  [tableParams]="tableParams"
  (lazyLoad)="loadOrders($event, undefined)">
</app-order-grid>
